module.exports = __webpack_public_path__ + "img/build-cleanroom-painting.64abc4a2.jpg";